import { CircleMultipleOutlineIcon } from './CircleMultipleOutlineIcon';

/**
 * author: Google
 * id BAD0A147-6CA0-4BCF-88DF-8E8A4C247B0E
 * name circle-multiple-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-multiple-outline.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const TollIcon = CircleMultipleOutlineIcon;
export default TollIcon